import "./pagination.scss";
import React from "react";
import LeftChevron from "../../SVG/left-chevron";
import RightChevron from "../../SVG/right-chevron";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPrevious: () => void;
  onNext: () => void;
  disabled?: boolean;
  className?: string;
}

export function Pagination({
  currentPage,
  totalPages,
  onPrevious,
  onNext,
  disabled = false,
  className,
}: PaginationProps) {
  return (
    <div className={`pagination-container ${className}`}>
      <div className="pagination-controls">
        <div className="pagination-button-group">
          <button
            className="pagination-button prev-button"
            onClick={onPrevious}
            disabled={disabled || currentPage <= 1}
            aria-label="Previous page"
          >
            <div className="chevron-icon chevron-left">
              <LeftChevron />
            </div>
            <span>Prev</span>
          </button>
        </div>

        <div className="pagination-divider"></div>

        <div className="pagination-info">
          <span>{currentPage}</span>
          &nbsp;of {totalPages}
        </div>

        <div className="pagination-divider"></div>

        <div className="pagination-button-group">
          <button
            className="pagination-button next-button"
            onClick={onNext}
            disabled={disabled || currentPage >= totalPages}
            aria-label="Next page"
          >
            <span>Next</span>
            <div className="chevron-icon chevron-right">
              <RightChevron />
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
